import { findIndex, filter } from 'lodash'

import i18n from '@/i18n/i18n'

import { AchievementService } from '@/services/admin/AchievementService'

import { errorMessage } from '@/utilities/helpers.js'
import money from '@/utilities/money'

import { GOAL_TYPES } from '@/constants/constants'

const { t } = i18n.global

export const namespaced = true

export const state = {
  achievements: [],
  achievement: {},
  goalId: null
}

export const mutations = {
  SET_ACHIEVEMENTS(state, achievements) {
    state.achievements = achievements
  },
  SET_ACHIEVEMENT(state, achievement) {
    state.achievement = achievement
    let index = findIndex(state.achievements, item => item.id === achievement.id)
    if (index === -1) {
      return
    }
    state.achievements[index] = achievement
  },
  ADD_ACHIEVEMENT(state, achievement) {
    state.achievements.push(achievement)
  },
  DELETE_ACHIEVEMENT(state, achievementId) {
    state.achievements = filter(state.achievements, function (achievement) {
      return achievement.id !== achievementId
    })
  },
  SET_GOAL_ID(state, goalId) {
    state.goalId = goalId
  }
}

export const getters = {
  getAchievementById: state => id => {
    return state.achievements ? state.achievements.find(achievement => achievement.id === id) : false
  }
}

export const actions = {
  getAchievements({ commit, dispatch, state }, goal) {
    if (state.achievements && state.goalId === goal.id) {
      return state.achievements
    }

    return new Promise((resolve, reject) => {
      AchievementService.getAchievements(goal.id)
        .then(response => {
          if (goal.type === GOAL_TYPES.ORDER_AMOUNT) {
            response.data.map(item => {
              item.goal = goal
            })
          }
          commit('SET_ACHIEVEMENTS', response.data)
          commit('SET_GOAL_ID', goal.id)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.achievements.breakdown_fetching_problem') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getAchievement({ commit, state, getters }, params) {
    if (params.achievementId === state.achievement.id) return state.achievement

    let achievement = getters.getAchievementById(params.achievementId)

    if (achievement) {
      commit('SET_ACHIEVEMENT', achievement)
      return achievement
    } else {
      return new Promise(resolve => {
        AchievementService.getAchievement(params.goal.id, params.achievementId).then(response => {
          if (params.goal.type === GOAL_TYPES.ORDER_AMOUNT) {
            response.data.goal = params.goal
          }
          commit('SET_ACHIEVEMENT', response.data)
          resolve(response.data)
        })
      })
    }
  },
  createAchievement({ commit, dispatch }, params) {
    // Hedef tipi satış tutarı ise, tl olarak gelen checkpoint'i 100 ile çarp
    if (params.goal.type === GOAL_TYPES.ORDER_AMOUNT) {
      params.achievement.checkpoint = money.of(parseFloat(params.achievement.checkpoint)).getMinorAmount()
    }

    return new Promise((resolve, reject) => {
      AchievementService.createAchievement(params.goal.id, params.achievement)
        .then(response => {
          if (params.goal.type === GOAL_TYPES.ORDER_AMOUNT) {
            response.data.goal = params.goal
          }
          commit('ADD_ACHIEVEMENT', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.achievements.breakdown_adding_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateAchievement({ commit, dispatch }, params) {
    if (params.goal.type === GOAL_TYPES.ORDER_AMOUNT) {
      params.achievement.checkpoint = money.of(parseFloat(params.achievement.checkpoint)).getMinorAmount()
    }

    return new Promise((resolve, reject) => {
      AchievementService.updateAchievement(params.goal.id, params.achievementId, params.achievement)
        .then(response => {
          if (params.goal.type === GOAL_TYPES.ORDER_AMOUNT) {
            response.data.goal = params.goal
          }
          commit('SET_ACHIEVEMENT', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.achievements.breakdown_update_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteAchievement({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      AchievementService.deleteAchievement(params.goalId, params.achievementId)
        .then(response => {
          commit('DELETE_ACHIEVEMENT', params.achievementId)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.achievements.breakdown_delete_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
